import { render, staticRenderFns } from "./BsDatePickerYears.vue?vue&type=template&id=80955d9c&scoped=true&"
import script from "./BsDatePickerYears.vue?vue&type=script&lang=js&"
export * from "./BsDatePickerYears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80955d9c",
  null
  
)

export default component.exports